import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useModalContext } from './modal-context-provider';

export type ModalBodyProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalBody = ({
  children,
  className,
  ...props
}: ModalBodyProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-modal__body');
  const { disableLegacy } = useModalContext();
  useEffect(() => disableLegacy(), []);

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};
